import React, { useEffect, useState } from 'react'
import { AiOutlineRightCircle, AiOutlineClose } from 'react-icons/ai'
import styled from 'styled-components';

interface WrapperProps {
    top: number
}

const Wrapper = styled.div<WrapperProps>`
    display: flex;
    position: absolute;
    width: 100%;
    height: 100vh;
    top: ${(props) => props.top}px;
    left: 0;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.7);
    align-items: center;
    justify-content: center;

    .container {
        padding: 24px;
        position: relative;
        color: ${props => props.theme.colors.background};
        background-color: ${props => props.theme.colors.text};
        border-radius: 10px;
        width: 600px;

        h2 {
            margin: 0 0 16px 0;
        }

        ul {
            display: flex;
            flex-direction: column;
            gap: 6px;
        }

        li {
            display: flex;
            list-style: none;
            align-items: center;
            gap: 4px;
        }

        .exit {
            position: absolute;
            top: 16px;
            right: 16px;
            border: none;
            cursor: pointer;
            background-color: transparent;
            color: ${props => props.theme.colors.background};
            font-size: 24px;
        }
    }
`

interface ModalProps {
    setModal: ((arg0: boolean) => void) | undefined
}

function Modal({ setModal }: ModalProps) {

    const [ top, setTop ] = useState(0)

    useEffect(() => {
        setTop(window.scrollY)
    }, [top, setTop])

    const handleClick = () => {
        if(setModal) {
            setModal(false)
        }
    }

    return (
        <Wrapper top={top} >
            <div className='container'>
                <h2>Gerenciamento de redes sociais</h2>
                <ul>
                    <li>
                        <AiOutlineRightCircle />
                        <span>Criação de calendário editorial.</span>
                    </li>
                    <li>
                        <AiOutlineRightCircle />
                        <span>Criação de calendário editorial.</span>
                    </li>
                    <li>
                        <AiOutlineRightCircle />
                        <span>Criação de calendário editorial.</span>
                    </li>
                    <li>
                        <AiOutlineRightCircle />
                        <span>Criação de calendário editorial.</span>
                    </li>
                </ul>
                <button className='exit' onClick={handleClick}><AiOutlineClose/></button>
            </div>
        </Wrapper>
    );
}

export default Modal;